import { Stack, Typography } from "@mui/material";
import { TipSelector } from "Components/Shared/TipSelector/TipSelector";
import type { TipMode } from "Components/Shared/TipSelector/types";
import { Resources, useResource } from "Translations/Resources";

const PageResources = Resources.Customer.Pay;

type Props = {
  tipMode: TipMode;
  customTipAmount?: number;
  currencyCode?: string;
  onTipModeChange: (mode: TipMode) => void;
  onCustomTipAmountChange: (amount: number | undefined) => void;
};

export const TipSection = ({
  tipMode,
  customTipAmount,
  currencyCode,
  onTipModeChange,
  onCustomTipAmountChange,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={4}>
      <Typography
        fontSize={14}
        fontWeight={500}
        lineHeight="20px"
        color="black"
        textTransform="uppercase"
      >
        {t(PageResources.AddTip)}
      </Typography>
      <TipSelector
        tipMode={tipMode}
        customTipAmount={customTipAmount}
        currencyCode={currencyCode}
        onTipModeChange={onTipModeChange}
        onCustomTipAmountChange={onCustomTipAmountChange}
      />
    </Stack>
  );
};
